import Table from "../../components/Table/Table";
import Actions from "../../components/Actions/Actions";
import Button from "../../components/Button/Button";
import {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import "./SentEmails.scss";
import PageLayout from "../../components/PageLayout/PageLayout";
import {emailIcon} from "../../components/Icon/Icon";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import sentEmailsActions from "../../api/SentEmailsActions";

const SentEmails = () => {
    const [emails, setEmails] = useState([]);
    const [deleteModal, setDeleteModal] = useState(null);
    const [deleteAllModal, setDeleteAllModal] = useState(null);
    const navigate = useNavigate();


    useEffect(() => {
        sentEmailsActions.loadSentEmails(setEmails);
    }, []);

    const handleDelete = () => {
        if (!deleteModal) return;
        sentEmailsActions.deleteSentEmail(deleteModal.id, (result) => {
            if (result.success) {
                setDeleteModal(null);
                sentEmailsActions.loadSentEmails(setEmails);
            }
        });
    };

    const handleDeleteAll = () => {
        sentEmailsActions.deleteAllSentEmails((result) => {
            if (result.success) {
                setDeleteAllModal(false);
                sentEmailsActions.loadSentEmails(setEmails);
            }
        });
    };

    const columns = useMemo(() => [
        {
            accessorKey: "sender",
            header: "From",
        },
        {
            accessorKey: "recipient",
            header: "To",
        },
        {
            accessorKey: "subject",
            header: "Subject",
        },
        {
            accessor: "sentAt",
            header: "Sent at",
            cell: ({row}) => <span>{row.original.sentAt}</span>,
        },
        {
            accessorKey: "actions",
            header: "Actions",
            cell: ({row}) => (
                <Actions
                    onEdit={() => navigate(`/sent-emails/${row.original.id}`)}
                    onDelete={() => setDeleteModal(row.original)}
                />
            ),
        },
    ], []);


    return (
        <PageLayout
            titlePage="Sent Emails"
            icon={emailIcon}
            className='sent-emails'
            actions={
                <>
                    {emails.length > 0 && (
                        <Button onClick={() => setDeleteAllModal(true)} variant="secondary">
                            Delete all
                        </Button>
                    )}
                </>
            }
        >
            {emails.length !== 0 && <Table data={emails} columns={columns}/>}
            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={handleDelete}
                    title="Delete email"
                    message={`Are you sure you want to delete email to "${deleteModal?.recipient}"?`}
                />
            }

            {
                deleteAllModal &&
                <DeleteModal
                    onClose={() => setDeleteAllModal(null)}
                    onConfirm={handleDeleteAll}
                    title="Delete all emails"
                    message="Are you sure you want to delete all sent emails?"
                />
            }
        </PageLayout>
    );
};

export default SentEmails;
